module.exports = __webpack_public_path__ + "static/media/car3.ad95c0af.svg";